import React, { useMemo } from "react";

// Deterministic pseudo-waveform from a string id (stable per track).
function heights(id, count) {
  let seed = 0;
  for (let i = 0; i < (id || "x").length; i++) seed = (seed * 31 + id.charCodeAt(i)) >>> 0;
  const out = [];
  for (let i = 0; i < count; i++) {
    seed = (seed * 1103515245 + 12345) & 0x7fffffff;
    const base = 0.25 + (seed % 1000) / 1000 * 0.75;
    // gentle envelope so it looks musical (louder in the middle)
    const env = 0.6 + 0.4 * Math.sin((i / count) * Math.PI);
    out.push(Math.max(0.12, Math.min(1, base * env)));
  }
  return out;
}

export function Waveform({ trackId, progress = 0, playing = false, bars = 48, onSeek, className = "" }) {
  const hs = useMemo(() => heights(trackId, bars), [trackId, bars]);
  const activeIndex = Math.floor((progress / 100) * bars);
  return (
    <div
      className={`flex items-end gap-[2px] h-8 cursor-pointer select-none ${className}`}
      onClick={(e) => {
        if (!onSeek) return;
        const rect = e.currentTarget.getBoundingClientRect();
        onSeek(((e.clientX - rect.left) / rect.width) * 100);
      }}
      data-testid="waveform"
    >
      {hs.map((h, i) => {
        const played = i <= activeIndex;
        const isHead = i === activeIndex && playing;
        return (
          <span
            key={i}
            className={`flex-1 rounded-full transition-colors duration-150 ${played ? "bg-violet-400" : "bg-zinc-700"} ${isHead ? "wf-head" : ""}`}
            style={{ height: `${h * 100}%` }}
          />
        );
      })}
    </div>
  );
}
